import apiClient, { IMAGE_BASE_URL } from "../network/apiClient";
import ShowNotifications from "../utils/notification";

const fileUrl = (file) => {
  if (!file) return "";
  if (file.url) return file.url;
  if (file.docPath && file.docName) return `${IMAGE_BASE_URL}/${file.docPath}/${file.docName}`;
  return "";
};

class BlogApi {
  async list(params = {}) {
    const response = await apiClient.get("/blog", { params });
    return response.data;
  }

  async get(id) {
    const response = await apiClient.get(`/blog/${id}`);
    return response.data?.data;
  }

  async create(payload) {
    const response = await apiClient.post("/blog", payload);
    ShowNotifications.showAlertNotification(response.data.message, true);
    return response.data?.data;
  }

  async update(id, payload) {
    const response = await apiClient.put(`/blog/${id}`, payload);
    ShowNotifications.showAlertNotification(response.data.message, true);
    return response.data?.data;
  }

  async remove(id) {
    const response = await apiClient.delete(`/blog/${id}`);
    ShowNotifications.showAlertNotification(response.data.message, true);
    return response.data;
  }

  async publish(id) {
    const response = await apiClient.post(`/blog/${id}/publish`);
    ShowNotifications.showAlertNotification(response.data.message, true);
    return response.data?.data;
  }

  async unpublish(id) {
    const response = await apiClient.post(`/blog/${id}/unpublish`);
    ShowNotifications.showAlertNotification(response.data.message, true);
    return response.data?.data;
  }

  async uploadMedia(file, folder = "blog") {
    const formData = new FormData();
    formData.append("images", file);
    formData.append("folder", folder);
    formData.append("type", "img");
    const response = await apiClient.post("/upload", formData);
    const uploaded = response.data?.data?.[0];
    return { ...uploaded, url: fileUrl(uploaded) };
  }
}

const blogApi = new BlogApi();
export { fileUrl };
export default blogApi;
